module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/edd3014da582ab3635dca5a05669a3f9.png";